const Tbody = ({children})=>{
  return (
    <tbody>
      {children}
    </tbody>
  )
}

export default Tbody;